define('tableFieldView',[
    'module',
    'marionette',
    'underscore',
    'template!tableFieldView'
], function (
    Module,
    Marionette,
    _,
    Tpl
) {
    'use strict';

    Module.exports = Marionette.LayoutView.extend({
        template: Tpl,
        className: 'table-field-view',

        initialize: function () {
            this.tableView = this.options.tableView;
            this.rowView = this.options.rowView;
            this.field = this.options.field;

            // Bind with listenTo (not model.on) so Marionette tears the
            // binding down when this field view is destroyed. With model.on
            // the handler leaked: a destroyed field view stayed subscribed
            // to its model, and a later attribute change re-invoked render()
            // on the dead view -> ViewDestroyedError. This bites hardest
            // with shared/Backbone-Relational models (e.g. the chat inbox),
            // where the same model instance outlives many field views.
            if(this.field.modelEvent)
                this.listenTo(this.model, this.field.modelEvent, this.render);
        },

        /*modelEvents: {
          change: 'render'
        },*/

        onBeforeRender: function() {
            if(this.field && this.field.className)
                this.$el.addClass(this.field.className);
        },

        onRender: function() {
            try {
                if(this.field.onRender) {
                    this.field.onRender(this);
                } else {
                    if(this.field.bind) {
                        var value = this.model.get(this.field.bind);

                        if(value !== undefined && value !== null) {
                            // Use formatter if provided, otherwise use raw value
                            var displayValue = value;
                            if(this.field.formatter && typeof this.field.formatter === 'function') {
                                displayValue = this.field.formatter(value, this.model);
                            }

                            this.$el.html(displayValue);
                            this.$el.attr('title', displayValue);
                        }
                    }
                }
            } catch(e) {
                console.log('row field view error: ', e);
            }
        }
    });
});
